// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import React from "react";

import {
  formatWorkflowsDate,
  formatWorkflowsDateString,
} from "../../../../utils";
import { DetailsSubheading, SecureDetailsContent } from "../../styles";
import { ResidentProfileProps } from "../../types";

export function UsIdCustodyLevelDowngradeReleaseDates({
  resident,
}: ResidentProfileProps): React.ReactElement<any> | null {
  if (resident.metadata.stateCode !== "US_ID") {
    return null;
  }

  return (
    <>
      <DetailsSubheading>Tentative Parole Date</DetailsSubheading>
      <SecureDetailsContent>
        {formatWorkflowsDateString(
          resident.metadata.tentativeParoleDate,
          "Not set",
        )}
      </SecureDetailsContent>
      <DetailsSubheading>Full Term Release Date</DetailsSubheading>
      <SecureDetailsContent>
        {resident.onLifeSentence
          ? "Life sentence"
          : formatWorkflowsDate(resident.releaseDate)}
      </SecureDetailsContent>
    </>
  );
}
